import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

export const memberStore = {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/member/index.js